exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app[data-v-7ba5bd90] {\n  max-width: 900px;\n  min-height: 100%;\n  margin: 0 auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  position: relative;\n}\n", ""]);

// exports
